import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'st-recommendation-panel',
  templateUrl: './recommendation-panel.component.html',
  styleUrls: ['./recommendation-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecommendationPanelComponent {
  @Input() success: boolean = true;
  @Input() withPadding: boolean = true;
}
